module.exports = new __parcel__URL__("Brainstorming Hover.84a73d80.svg").toString();